$(document).ready(function(){
    jQuery('.scrollTo').click(function(e) {
        let jump = jQuery(this).attr('href');
        let new_position = jQuery(jump).offset();
        let scroll = 0;
        jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function(){
            let new_position = jQuery(jump).offset();
            jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
        });
        e.preventDefault();
    });

    // Menu open close Script Start Here
    $('.js-open-menu').click(function(){
        $('body').addClass('open-menu');
    });
    $('.js-close-menu').click(function(){
        $('body').removeClass('open-menu');
    });

    $(document).on("click", function(event){
        let $trigger = $(".js-open-menu, .cw-header__nav");
        if($trigger !== event.target && !$trigger.has(event.target).length){
            $('body').removeClass('open-menu');
        }
    });
    // Menu open close Script End Here

    // USPA Slider Start Here
    if($('.js-uspa-slider').length > 0){
        $('.js-uspa-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            variableWidth: true,
            dots: false,
            draggable: false,
            pauseOnHover: false,
            swipeToSlide: false,
            prevArrow: '<button type="button" class="prev-arrow"><span class="ada_empty_link" style="display:none;">.</span><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.677032 8.21648C0.305465 7.84492 0.305465 7.24249 0.677032 6.87092L6.73206 0.815889C7.10363 0.444322 7.70606 0.444322 8.07763 0.815889C8.44919 1.18746 8.44919 1.78988 8.07763 2.16145L2.69538 7.5437L8.07763 12.926C8.44919 13.2975 8.44919 13.8999 8.07763 14.2715C7.70606 14.6431 7.10363 14.6431 6.73206 14.2715L0.677032 8.21648ZM2.30127 8.49516H1.34981V6.59224H2.30127V8.49516Z" fill="black"/></svg></button>',
		    nextArrow: '<button type="button" class="next-arrow"><span class="ada_empty_link" style="display:none;">.</span><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.10031 8.21648C8.47188 7.84492 8.47188 7.24249 8.10031 6.87092L2.04528 0.815889C1.67371 0.444322 1.07129 0.444322 0.699718 0.815889C0.328152 1.18746 0.328152 1.78988 0.699718 2.16145L6.08197 7.5437L0.699718 12.926C0.328152 13.2975 0.328152 13.8999 0.699718 14.2715C1.07129 14.6431 1.67371 14.6431 2.04528 14.2715L8.10031 8.21648ZM6.47607 8.49516H7.42753V6.59224H6.47607V8.49516Z" fill="black"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        variableWidth: false,
                    }
                }
            ]
        });
    }
    // USPA Slider Start Here

    // Customer Review Slider Start Here
    if($('.js-icon-text-slider').length > 0){
        $('.js-icon-text-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            draggable: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: true
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });
    }
    // Customer Review Slider End Here

    // js-after-before-slider Slider Start Here
    if($('.js-after-before-slider').length > 0){
        $('.js-after-before-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            draggable: false,
            dots: true,
            prevArrow: '<button type="button" class="prev-arrow"><span class="ada_empty_link" style="display:none;">.</span><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" fill="white" stroke="black"/><path d="M9.46967 19.4697C9.17678 19.7626 9.17678 20.2374 9.46967 20.5303L14.2426 25.3033C14.5355 25.5962 15.0104 25.5962 15.3033 25.3033C15.5962 25.0104 15.5962 24.5355 15.3033 24.2426L11.0607 20L15.3033 15.7574C15.5962 15.4645 15.5962 14.9896 15.3033 14.6967C15.0104 14.4038 14.5355 14.4038 14.2426 14.6967L9.46967 19.4697ZM30 19.25H10V20.75H30V19.25Z" fill="black"/></svg></button>',
		    nextArrow: '<button type="button" class="next-arrow"><span class="ada_empty_link" style="display:none;">.</span><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" fill="white" stroke="black"/><path d="M30.5303 19.4697C30.8232 19.7626 30.8232 20.2374 30.5303 20.5303L25.7574 25.3033C25.4645 25.5962 24.9896 25.5962 24.6967 25.3033C24.4038 25.0104 24.4038 24.5355 24.6967 24.2426L28.9393 20L24.6967 15.7574C24.4038 15.4645 24.4038 14.9896 24.6967 14.6967C24.9896 14.4038 25.4645 14.4038 25.7574 14.6967L30.5303 19.4697ZM10 19.25H30V20.75H10V19.25Z" fill="black"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: true
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });
    }
    // js-after-before-slider Slider End Here

    // js-ugc-slider Slider Start here
    if($('.js-ugc-slider').length > 0){
        $('.js-ugc-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            dots: true,
            draggable: false,
            centerMode: true,
            initialSlide: 1,
            variableWidth: false,
            prevArrow: '<button type="button" class="prev-arrow"><span class="ada_empty_link" style="display:none;">.</span><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" fill="white" stroke="black"/><path d="M9.46967 19.4697C9.17678 19.7626 9.17678 20.2374 9.46967 20.5303L14.2426 25.3033C14.5355 25.5962 15.0104 25.5962 15.3033 25.3033C15.5962 25.0104 15.5962 24.5355 15.3033 24.2426L11.0607 20L15.3033 15.7574C15.5962 15.4645 15.5962 14.9896 15.3033 14.6967C15.0104 14.4038 14.5355 14.4038 14.2426 14.6967L9.46967 19.4697ZM30 19.25H10V20.75H30V19.25Z" fill="black"/></svg></button>',
		    nextArrow: '<button type="button" class="next-arrow"><span class="ada_empty_link" style="display:none;">.</span><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" fill="white" stroke="black"/><path d="M30.5303 19.4697C30.8232 19.7626 30.8232 20.2374 30.5303 20.5303L25.7574 25.3033C25.4645 25.5962 24.9896 25.5962 24.6967 25.3033C24.4038 25.0104 24.4038 24.5355 24.6967 24.2426L28.9393 20L24.6967 15.7574C24.4038 15.4645 24.4038 14.9896 24.6967 14.6967C24.9896 14.4038 25.4645 14.4038 25.7574 14.6967L30.5303 19.4697ZM10 19.25H30V20.75H10V19.25Z" fill="black"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    $('.cw-ugc__content .box .video-controls').find('.js-icon-play').hide();
    $(document).on("click", ".video-controls", function () {
        let clickedVideo = $(this).parents('.box').find(".ugc-video").get(0);
        
        $(".ugc-video").not(clickedVideo).each(function () {
            this.pause();
            $(this).siblings('.video-controls').find('.js-icon-pause').show();
            $(this).siblings('.video-controls').find('.js-icon-play').hide();
        });

        if (clickedVideo.paused) {
            clickedVideo.play();
            $(this).find('.js-icon-pause').hide();
            $(this).find('.js-icon-play').show();
        } else {
            clickedVideo.pause();
            $(this).find('.js-icon-play').hide();
            $(this).find('.js-icon-pause').show();
        }
    });
    // js-ugc-slider Slider End here

    // product-details slider start here
    if($('.js-product-main').length > 0){
        $('.js-product-main').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            focusOnSelect: false,
            infinite: true,
            speed: 500,
            fade: true,
            draggable: false,
            asNavFor: '.js-product-nav',
            prevArrow: '<button type="button" class="prev-arrow"><span class="ada_empty_link" style="display:none;">.</span><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" fill="white" stroke="black"/><path d="M9.46967 19.4697C9.17678 19.7626 9.17678 20.2374 9.46967 20.5303L14.2426 25.3033C14.5355 25.5962 15.0104 25.5962 15.3033 25.3033C15.5962 25.0104 15.5962 24.5355 15.3033 24.2426L11.0607 20L15.3033 15.7574C15.5962 15.4645 15.5962 14.9896 15.3033 14.6967C15.0104 14.4038 14.5355 14.4038 14.2426 14.6967L9.46967 19.4697ZM30 19.25H10V20.75H30V19.25Z" fill="black"/></svg></button>',
		    nextArrow: '<button type="button" class="next-arrow"><span class="ada_empty_link" style="display:none;">.</span><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" fill="white" stroke="black"/><path d="M30.5303 19.4697C30.8232 19.7626 30.8232 20.2374 30.5303 20.5303L25.7574 25.3033C25.4645 25.5962 24.9896 25.5962 24.6967 25.3033C24.4038 25.0104 24.4038 24.5355 24.6967 24.2426L28.9393 20L24.6967 15.7574C24.4038 15.4645 24.4038 14.9896 24.6967 14.6967C24.9896 14.4038 25.4645 14.4038 25.7574 14.6967L30.5303 19.4697ZM10 19.25H30V20.75H10V19.25Z" fill="black"/></svg></button>',
        });
    }
    if($('.js-product-nav').length > 0){
        $('.js-product-nav').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false,
            focusOnSelect: true,
            infinite: true, 
            draggable: false,           
            asNavFor: '.js-product-main'            
        });
    }
    $(window).on('load resize', function() {
        if ($('.js-product-nav .slide').length <= 5) {
            console.log('slider');
            $('.cw-product-details .js-product-nav, .cw-product-details-banner .js-product-nav').addClass('no-scroll-slider');
        } else {
            // Optional: Remove the class if the condition is not met
            $('.cw-product-details .js-product-nav, .cw-product-details-banner .js-product-nav').removeClass('no-scroll-slider');
        }
    });
    
    // product-details slider end here

    // js-product-review Slider Start here
    if($('.js-product-review').length > 0){
        $('.js-product-review').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            dots: true,
            prevArrow: '<button type="button" class="prev-arrow"><span class="ada_empty_link" style="display:none;">.</span><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" fill="white" stroke="black"/><path d="M9.46967 19.4697C9.17678 19.7626 9.17678 20.2374 9.46967 20.5303L14.2426 25.3033C14.5355 25.5962 15.0104 25.5962 15.3033 25.3033C15.5962 25.0104 15.5962 24.5355 15.3033 24.2426L11.0607 20L15.3033 15.7574C15.5962 15.4645 15.5962 14.9896 15.3033 14.6967C15.0104 14.4038 14.5355 14.4038 14.2426 14.6967L9.46967 19.4697ZM30 19.25H10V20.75H30V19.25Z" fill="black"/></svg></button>',
		    nextArrow: '<button type="button" class="next-arrow"><span class="ada_empty_link" style="display:none;">.</span><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="39" height="39" rx="19.5" transform="matrix(-1 0 0 1 39 0)" fill="white" stroke="black"/><path d="M30.5303 19.4697C30.8232 19.7626 30.8232 20.2374 30.5303 20.5303L25.7574 25.3033C25.4645 25.5962 24.9896 25.5962 24.6967 25.3033C24.4038 25.0104 24.4038 24.5355 24.6967 24.2426L28.9393 20L24.6967 15.7574C24.4038 15.4645 24.4038 14.9896 24.6967 14.6967C24.9896 14.4038 25.4645 14.4038 25.7574 14.6967L30.5303 19.4697ZM10 19.25H30V20.75H10V19.25Z" fill="black"/></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2 
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        arrows: false
                    }
                }
            ]
        });
    }
    // js-product-review Slider End here
    
    if($('.cw-naturally-beneficial-drink-v1__content .info-box-wrap .desc-text').length > 0){
        $('.cw-naturally-beneficial-drink-v1__content .info-box-wrap .desc-text').matchHeight({
            byRow: false,
        });        
    }
    if($('.cw-hp-perfect-head-hair__wrap .box h4').length > 0){
        $('.cw-hp-perfect-head-hair__wrap .box h4').matchHeight({
            byRow: true,
        });        
    }
    if($('.cw-hp-perfect-head-hair__wrap .box .box__desc').length > 0){
        $('.cw-hp-perfect-head-hair__wrap .box .box__desc').matchHeight({
            byRow: true,
        });        
    }
    
    // Accordian js Start here
    $(function () {
        $('.js-accordian-title').click(function (j) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parents('.cus-accordian').find('.cus-accordian__card').removeClass('active');
                $(this).next().slideUp();
            } else{
                $('.js-accordian-title').removeClass('active');
                $(this).parents('.cus-accordian').find('.cus-accordian__card').removeClass('active');
                $('.js-accordian-title').next().slideUp();
                $(this).addClass('active');
                $(this).parents('.cus-accordian__card').addClass('active');
                $(this).next().slideDown(function(){
                    $(this).css('display', 'block');
                });
            }
            
        });
    }); 
    // Accordian js End here

    // Product QTY js start here
    $(document).on('click','.js-button', function () {
        let val = parseInt($(this).parent().find("input").val());
      
        if ($(this).hasClass("less")) {
          val = val - 1;
        } else if ($(this).hasClass("more")) {
          val = val + 1;
        }      
        if (val < 1) {
          val = 1;
        }      
        $(this).parent().find("input").val(val);
    });      
    // Product QTY js end here

    Fancybox.bind("[data-fancybox]");
});

/* STICKY HEADER */
$(document).ready(function () {
    var header = $(".cw-header");

    // Sticky Header on Scroll with Smooth Transition
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            header.addClass("header_fixed").css("top", "-50px").animate({ top: "0" }, 300);
        } else {
            header.removeClass("header_fixed");
        }
    });

});
/* STICKY HEADER */

/* STICKY ADD TO CART */
$(document).ready(function () {
  // For Mobile/Tablet
  if ($(window).width() <= 991) { 
    var sticky_add_to_cart_mobile = $(".cw-btn.product_page_atc");

    // Sticky Header on Scroll with Smooth Transition
    $(window).scroll(function () {
        if ($(this).scrollTop() > 2000) {
            sticky_add_to_cart_mobile.addClass("sticky_add_to_cart");
        } else {
            sticky_add_to_cart_mobile.removeClass("sticky_add_to_cart");
        }
    });
  }
  // For Mobile/Tablet

  // For Desktop
    if ($(window).width() >= 992) { 
    var sticky_buy_now_desktop = $(".cw-buy-now-btn-desktop");

    // Sticky Header on Scroll with Smooth Transition
    $(window).scroll(function () {
        if ($(this).scrollTop() > 1000) {
            sticky_buy_now_desktop.addClass("sticky_buy_now");
        } else {
            sticky_buy_now_desktop.removeClass("sticky_buy_now");
        }
    });
  }

    $(".cw-buy-now-btn-desktop").on("click", function (event) {
        event.preventDefault(); // Prevent default action if it's a link
        $("html, body").animate({ scrollTop: 0 }, 600); // Smooth scroll to top
    });


  // For Desktop
});
/* STICKY ADD TO CART */